<script setup>
import { computed } from "vue";
import { getPermitForBusiness } from "@/utils/functions";
import ActionsContainer from "../utils/ActionsContainer.vue";
import ActionButton from "../utils/ActionButton.vue";
import { actions } from "@/utils/constants";
import Table from "../utils/Table.vue";

const props = defineProps({
  businesses: {
    type: Array,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const businessesNotEmpty = computed(() => {
  return props.businesses !== null && props.businesses.length > 0;
});

function getSbpNumber(business) {
  const permit = getPermitForBusiness(business);
  return permit?.sbp_number ?? 'N/A';
}

function getBusinessStatus(business) {
  const permit = getPermitForBusiness(business);
  return permit?.permit_status ?? null;
}

function getBusinessActivity(business) {
  const businessActivity = business.business_activity;
  const businessActivityNotEmpty =
    businessActivity !== null && businessActivity !== undefined;
  if (businessActivityNotEmpty) {
    return businessActivity.activity_name;
  }
  return "N/A";
}

function getBusinessTown(business) {
  // return getTownFromSubcountyAndWard({
  //     subcountyId: business.sub_county_id,
  //     wardId: business.ward_id,
  //     townId: business.town_id
  // }) ?? 'N/A'
  return business?.town?.town_name ?? "N/A";
}

function getColorForBusinessStatus(business) {
  const status = getBusinessStatus(business);
  if (!status || typeof status !== "string") return 'grey';
  const lowerCaseStatus = status.toLowerCase();
  if (lowerCaseStatus === "approved") {
    return "success";
  } else if (lowerCaseStatus === "expired") {
    return "error";
  } else if (lowerCaseStatus === "pending") {
    return "purple";
  }
  return 'grey';
}
</script>

<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="12">
        <div :style="{ position: 'relative' }">
          <v-progress-linear v-if="loading" indeterminate class="mb-4" />

          <Table :headers="[
            { text: 'SBP Number', value: 'sbp_number' },
            { text: 'Business Name', value: 'business_name' },
            { text: 'Business Activity', value: 'business_activity' },
            { text: 'Town', value: 'town' },
            { text: 'Status', value: 'status' },
            { text: 'View', value: 'view', action: true },
            { text: 'Renew', value: 'renew', action: true },
          ]" :items="businesses" headClasses="primary white--text" :loading="loading" emptyText="No Businesses Found">
            <template #itemTitle="{ item: business }">
              {{ business.business_name }}
            </template>
            <template #item.sbp_number="{ item: business }">
              <v-tooltip v-if="business.lock_renewal == 1" top>
                <template #activator="{ on, attrs }">
                  <div class="d-flex flex-column align-start secondary--text" v-bind="attrs" v-on="on">
                    {{ getSbpNumber(business) }}
                    <div v-if="business.lock_renewal == 1" class="text-caption d-flex" :style="{ gap: '4px' }">
                      <div class="text-caption text-no-wrap">Permit Locked</div>
                      <v-icon small :style="{ color: 'inherit' }">mdi-alert-circle-outline</v-icon>
                    </div>
                  </div>
                </template>
                <span>This business permit is locked. Please visit your nearest county office to renew it</span>
              </v-tooltip>
              <template v-else>
                {{ getSbpNumber(business) }}
              </template>

            </template>

            <template #item.business_activity="{ item: business }">
              {{ getBusinessActivity(business) }}
            </template>

            <template #item.town="{ item: business }">
              {{ getBusinessTown(business) }}
            </template>

            <template #item.status="{ item: business }">
              <v-chip :color="getColorForBusinessStatus(business)" text-color="white" small>
                {{ getBusinessStatus(business) }}
              </v-chip>
              <!-- <span :class="[getColorForBusinessStatus(business), 'white--text']">
                {{ getBusinessStatus(business) }}
              </span> -->
            </template>

            <template #item.view="{ item: business }">
              <ActionButton :action="actions.view" inTable @click="$emit('viewBusiness', business)" />
            </template>

            <template #item.renew="{ item: business }">
              <ActionButton :action="actions.renewPermit" inTable @click="$emit('renewPermit', business)" />
            </template>
          </Table>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
